/* global document */
import Global from './global';

document.addEventListener('DOMContentLoaded', () => {
  const g = new Global();
  g.init();
});



// WEBPACK FOOTER //
// ./assets/js/main.js